export function getText(person) {
  if ('patient' in person) {
    let { patient } = person
    let { primary_location, human_readable_id } = patient

    return [primary_location?.name, `#${human_readable_id}`]
      .filter(Boolean)
      .join(' • ')
      .trim()
  } else {
    return `${
      person.is_external_professional ? 'External professional' : ''
    } (${person.location.name})`
  }
}
